module.exports = __webpack_public_path__ + "static/media/microsoft-onedrive.5e64e1e1.png";